import { useEffect } from 'react';
import { useBrand } from 'src/shared/hooks/useBrand';
import { BRAND_ICON_HREFS } from './brandIconHrefs';

const setHref = (selector: string, href: string) => {
  document.querySelectorAll<HTMLLinkElement>(selector).forEach((link) => {
    link.href = href;
  });
};

/**
 * The server already renders the right icon links per host. This covers the places no server
 * renders `index.html` — local dev and the S3 previews — plus the dev-only `?as=tablerun` override.
 */
export const useBrandFavicon = (): void => {
  const brand = useBrand();

  useEffect(() => {
    const { favicon, touchIcon } = BRAND_ICON_HREFS[brand];
    setHref('link[rel="shortcut icon"]', favicon);
    setHref('link[rel="apple-touch-icon"]', touchIcon);
  }, [brand]);
};
